import http, { url } from '../../http'

const API_URL = "pension_payment"

class prevencionEmergenciasAPI {

  async save(resource) {
    const response = await http(`${API_URL}/save`, 'POST', resource)
    return response
  }

  async getAll(id, page, search) {
    const response = await http(`${API_URL}/company/${id}?page=${page}&search=${search}`, 'POST')
    return response
  } 

/*   async getAll(id, page) {
    const response = await http(`${API_URL}/companies/${id}?page=${page}`)
    return response
  }  */
 
  async get(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }

  async getPension(id) {
    const response = await http(`${API_URL}/company/${id}`, 'POST')
    return response
  }

    async getShow(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }

  async update(id, resource) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', resource)
    return response
  }

  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  } 
  
}

export default new prevencionEmergenciasAPI()